export default "__VITE_ASSET__CkjnNRC$__"